exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* --------------- Contact --------------- */\n\n.contact .contact-info {\n\tmargin: 0 0 30px 0;\n}\n.contact .contact-info p.hotel-info {\n\tline-height: 1.8;\n}\n.contact .mat-card.contact-form {\n\tmargin: 0;\n\tpadding: 15px;\n}\n.contact .mat-card.contact-form .mat-input-container {\n\tmargin: 0;\n}\n.contact  .mat-card.contact-form .captcha .re-captcha {\n\twidth: 302px;\n\theight: 78px;\n\tmargin: 0 0 15px 0;\n\tpadding: 0;\n\tfloat: right;\n\tright: 0;\n}\n.contact  .mat-card.contact-form .send-button .mat-raised-button {\n\twidth: 302px;\n\tfloat: right;\n}\n.contact .footer-contact-map {\n\twidth: 100% !important;\n\theight: 300px !important;\n\tmargin: 30px 0 -30px 0;\n\tpadding: 0;\n}\n.contact .sebm-google-map-container {\n\theight: 300px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.css
// module id = ./src/app/contact/contact.component.css
// module chunks = 1